import request from '@/providers/http-service'
const url = '/tbase-iam-manage'
// 查询日志列表
export function getLogList(params) { //
  return request({
    url: url + '/userLogDiy/page',
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/logManagement.js